module.exports = __webpack_public_path__ + "img/base_patrimoine_chateaux.464cb3d3.svg";